/* eslint-disable react-hooks/exhaustive-deps */
import { Fragment, useEffect, useState } from 'react';

import { Grid, GridColumn, GridPageChangeEvent } from '@progress/kendo-react-grid';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

import '@progress/kendo-theme-default/dist/all.css';
import { AxiosResponse } from 'axios';
import { PageState } from '../../models/pagestate.model';
import { Pais } from '../../models/pais.model';
import { PaisesService } from '../../services/paises.service';
import { Link, useNavigate } from 'react-router-dom';
import { Programa } from '../../models/programas.model';
import { ProgramasService } from '../../services/programas.service';
import { ProgramaView } from '../../models/programasView.model';
import { UsersService } from '../../services/users.service';
import { CountriesUser, ProgramsUser, Users } from '../../models/users.model';
import ProgramaViewFilter from '../../models/programaViewFilter.model';
import Loading from '../shared/loading/Loading.component';

export default function UpdateData() {
    const user = JSON.parse(localStorage.getItem('currentUsr')!);
    const moment = require('moment');
    const paisesService = PaisesService({ locale: 'en' });
    const programasService = ProgramasService({ locale: 'en' });
    const usersService = UsersService({ locale: 'en' });
    const userRol = JSON.parse(localStorage.getItem('Roles') as string);
    const infra2_User: Users = JSON.parse(localStorage.getItem('Infra2_User') as string) as Users;
    const [paises, setPaises] = useState<Pais[]>([]);
    // const [programsFiltered, setProgramsFiltered] = useState<Programa[]>([]);
    const [programas, setProgramas] = useState<Programa[]>([]);
    const [programasView, setProgramasView] = useState<ProgramaView[]>([]);
    const [programasViewFiltered, setProgramasViewFiltered] = useState<ProgramaView[]>([]);

    const [countryFilter, setCountryFilter] = useState('');
    const [programFilter, setProgramFilter] = useState<string>('');
    const [yearFilter, setYearFilter] = useState('');
    const [monthFilter, setMonthFilter] = useState('');

    const [loading, setLoading] = useState<boolean>(false);

    const initialDataState: PageState = { skip: 0, take: 10 };
    // const [infra2User, setInfra2User] = useState<Users>();
    // const [userGroups, setUserGroups] = useState<UserGroup[]>([]);
    const [page, setPage] = useState<PageState>(initialDataState);

    const navigate = useNavigate();

    const handleChange = (event: any) => {
        setLoading(true);
        page.skip = 0;
        setPage(page);
        setTimeout(() => {
            setCountryFilter(event.target.value);
            filterProgramasView(event.target.value, programFilter, yearFilter, monthFilter);
            setLoading(false);
        }, 200);
        // TODO: Continue with filterProgramByCountry
        // filterProgramByCountry(event.target.value);
    };

    // const filterProgramByCountry = (country: any) => {
    //   if (country) {
    //     setProgramsFiltered(programas.filter((x: Programa) => x.codigo !== null));
    //   } else {
    //     setProgramsFiltered(programas);
    //   }
    // };

    const handleChange1 = (event: any) => {
        page.skip = 0;
        setPage(page);
        setLoading(true);
        let filterProgram: string = '';
        if (event.target.value) {
            const idIso = event.target.value;
            const programa = programas.filter((s) => s.descripcion === idIso);
            if (programa.length > 0) {
                filterProgram = programa[0].descripcion;
            }
        }
        setTimeout(() => {
            setProgramFilter(filterProgram);
            filterProgramasView(countryFilter, filterProgram, yearFilter, monthFilter);

            setLoading(false);
        }, 200);
    };

    const handleChangeYear = (event: any) => {
        setLoading(true);

        page.skip = 0;
        setPage(page);
        setTimeout(() => {
            setYearFilter(event.target.value);
            filterProgramasView(countryFilter, programFilter, event.target.value, monthFilter);
            setLoading(false);
        }, 200);
    };

    const filterProgramasView = (country: any, program: any, year: any, month: any) => {
        let programs = programasView.filter(
            (s) =>
                ((country && s.nombrePais === country) || !country) &&
                ((program && s.descripcionPrograma === program) || !program) &&
                ((year && s.year === year) || !year) &&
                ((month && s.month === month) || !month)
        );

        setProgramasViewFiltered(programs);
        page.skip = 0;
        setPage(page);
    };

    const handleChangeMonth = (event: any) => {
        setLoading(true);

        page.skip = 0;
        setPage(page);
        setTimeout(() => {
            setMonthFilter(event.target.value);
            filterProgramasView(countryFilter, programFilter, yearFilter, event.target.value);
            setLoading(false);
        }, 200);
    };

    const years = () => {
        let result = [];
        for (let i = new Date().getFullYear() - 10; i < new Date().getFullYear() + 10; i++) {
            result.push(i);
        }
        return result;
    };

    const months = () => {
        let result = [];
        for (let i = 0; i < 12; i++) {
            result.push(i + 1);
        }
        return result;
    };

    useEffect(() => {
        setLoading(true);
        requiredOnwer();
        requiredConsultant();
        requiredExecutor();
        requiredSpecialist();
        requiredAnalyst();

        if (user && localStorage.getItem('Roles') && localStorage.getItem('Infra2_User')) {
            // setInfra2User(infra2_User);
            // setUserGroups(userRol);
            paisesService.getPaises().then((pr: AxiosResponse) => {
                let countries: Pais[] = [];
                if (pr.data) {
                    infra2_User.countriesUser?.forEach((country: CountriesUser) => {
                        const item: Pais[] = pr.data.filter(
                            (s: Pais) => s.oid === country.countryId
                        );
                        if (item.length > 0) {
                            countries.push(item[0]);
                        }
                    });
                    setPaises(countries);
                    usersService.getInfra2_UserGroups().then((u: AxiosResponse) => {
                        programasService.getProgramas().then((p: AxiosResponse) => {
                            if (p.data) {
                                let programs: Programa[] = [];
                                infra2_User.programsUser?.forEach((program: ProgramsUser) => {
                                    const itemP = p.data.filter(
                                        (pro: Programa) => pro.oid === program.programId
                                    );
                                    if (itemP.length > 0) {
                                        programs.push(itemP[0]);
                                    }
                                });
                                setProgramas(programs);
                                // setProgramsFiltered(programs);
                                const filter: ProgramaViewFilter = {
                                    oid_Programs: programs.map((i) => i.oid),
                                    oid_Countries: countries.map((c) => c.oid as number),
                                };
                                programasService
                                    .getProgramasView(filter)
                                    .then((pv: AxiosResponse) => {
                                        if (pv.data) {
                                            pv.data.map((prog: ProgramaView) => {
                                                if (prog.fecha) {
                                                    const fecha = new Date(prog.fecha);
                                                    prog.year = fecha.getFullYear();
                                                    prog.month = fecha.getMonth() + 1;
                                                }
                                                return prog;
                                            });
                                            setProgramasView(pv.data);
                                            setProgramasViewFiltered(pv.data);
                                        }
                                        setLoading(false);
                                    });
                            }
                        });
                    });
                }
            });
        }
    }, []);

    const requiredOnwer = (): boolean => {
        let result = false;
        if (user && localStorage.getItem('Roles')) {
            const owner = userRol ? userRol.filter((s: any) => s.Name === 'Owner') : null;
            if (owner && owner.length > 0) {
                result = true;
            }
        }
        return result;
    };

    const requiredConsultant = (): boolean => {
        let result = false;
        if (user && localStorage.getItem('Roles')) {
            const consultant = userRol ? userRol.filter((s: any) => s.Name === 'Consultant') : null;
            if (consultant && consultant.length > 0) {
                result = true;
            }
        }
        return result;
    };
    const requiredExecutor = (): boolean => {
        let result = false;
        if (user && localStorage.getItem('Roles')) {
            const executor = userRol ? userRol.filter((s: any) => s.Name === 'Executor') : null;
            if (executor && executor.length > 0) {
                result = true;
            }
        }
        return result;
    };
    const requiredSpecialist = (): boolean => {
        let result = false;
        if (user && localStorage.getItem('Roles')) {
            const specialist = userRol ? userRol.filter((s: any) => s.Name === 'Specialist') : null;
            if (specialist && specialist.length > 0) {
                result = true;
            }
        }
        return result;
    };
    const requiredAnalyst = (): boolean => {
        let result = false;
        if (user && localStorage.getItem('Roles')) {
            const analyst = userRol ? userRol.filter((s: any) => s.Name === 'Analyst') : null;
            if (analyst && analyst.length > 0) {
                result = true;
            }
        }
        return result;
    };

    const pageChange = (event: GridPageChangeEvent) => {
        setPage(event.page);
    };

    return (
        <Fragment>
            <section id='updatedata' className='bg-gray'>
                {loading && (
                    <div className='loading-comp'>
                        <Loading />
                    </div>
                )}
                {!loading && (
                    <Fragment>
                        {requiredOnwer() && (
                            <div className='container'>
                                <div className='row'>
                                    <Link className='create' to='/create-program'>
                                        Actualizar proyectos avanzados
                                    </Link>
                                </div>
                            </div>
                        )}
                        <div className='container cont-in mt-5'>
                            <div className='row'>
                                <div className='col-12 col-md'>
                                    <FormControl className=''>
                                        <Select
                                            defaultValue={countryFilter}
                                            onChange={handleChange}
                                            displayEmpty
                                            className=''>
                                            <MenuItem value=''>País</MenuItem>

                                            {(paises || []).map((item, i) => {
                                                return (
                                                    <MenuItem key={i} value={item.nombre}>
                                                        {item.nombre}
                                                    </MenuItem>
                                                );
                                            })}
                                        </Select>
                                    </FormControl>
                                </div>
                                <div className='col-12 col-md'>
                                    {programas.length > 0 && (
                                        <FormControl className=''>
                                            <Select
                                                defaultValue={programFilter}
                                                onChange={handleChange1}
                                                displayEmpty
                                                className=''>
                                                <MenuItem value=''>Programa</MenuItem>
                                                {programas.map((item, i) => {
                                                    return (
                                                        <MenuItem key={i} value={item.descripcion}>
                                                            {item.descripcion}
                                                        </MenuItem>
                                                    );
                                                })}
                                            </Select>
                                        </FormControl>
                                    )}
                                </div>
                                <div className='col-12 col-md'>
                                    <FormControl className=''>
                                        <Select
                                            defaultValue={yearFilter}
                                            onChange={handleChangeYear}
                                            displayEmpty
                                            className=''>
                                            <MenuItem value=''>Año</MenuItem>
                                            {years().map((y: number, i) => {
                                                return (
                                                    <MenuItem key={i} value={y}>
                                                        {y}
                                                    </MenuItem>
                                                );
                                            })}
                                        </Select>
                                    </FormControl>
                                </div>
                                <div className='col-12 col-md'>
                                    <FormControl className=''>
                                        <Select
                                            defaultValue={monthFilter}
                                            onChange={handleChangeMonth}
                                            displayEmpty
                                            className=''>
                                            <MenuItem value=''>Mes</MenuItem>
                                            {months().map((y: number, i) => {
                                                return (
                                                    <MenuItem key={i} value={y}>
                                                        {y}
                                                    </MenuItem>
                                                );
                                            })}
                                        </Select>
                                    </FormControl>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-12 mt-50'>
                                    <div className='d-flex '>
                                        <Grid
                                            data={programasViewFiltered.slice(
                                                page.skip,
                                                page.take + page.skip
                                            )}
                                            filterable={false}
                                            skip={page.skip}
                                            take={page.take}
                                            pageable={true}
                                            onPageChange={pageChange}
                                            groupable={false}
                                            total={programasViewFiltered.length}>
                                            <GridColumn
                                                field='nombrePais'
                                                title='Pais'
                                                // width="150px"
                                                filterable={false}
                                            />
                                            <GridColumn
                                                field='descripcionPrograma'
                                                title='Programa'
                                                editor='text'
                                                // width="200PX"
                                                filterable={false}
                                            />
                                            <GridColumn
                                                filterable={false}
                                                field='fecha'
                                                title='Ultima actualización'
                                                editor='text'
                                                // width="350px"
                                                cell={(props: any) => (
                                                    <td>
                                                        {moment(props.dataItem.fecha).format(
                                                            'MM/DD/YYYY hh:MM A'
                                                        )}
                                                    </td>
                                                )}
                                            />

                                            <GridColumn
                                                title='Acciones'
                                                filterable={false}
                                                cell={(props: any) => (
                                                    <td>
                                                        {!requiredAnalyst() && (
                                                            <button
                                                                className='btns cl-green'
                                                                onClick={(e) => {
                                                                    navigate({
                                                                        pathname: `/update-data/${props.dataItem
                                                                                .oidPrograma
                                                                            }/${new Date(
                                                                                props.dataItem.fecha
                                                                            ).getFullYear()}/${new Date(
                                                                                props.dataItem.fecha
                                                                            ).getMonth() + 1
                                                                            }`,
                                                                    });
                                                                }}>
                                                                <span className='icon-edit'></span>
                                                            </button>
                                                        )}
                                                        <button>
                                                            <span className='icon-excel-Excel'></span>
                                                        </button>
                                                    </td>
                                                )}
                                            />
                                        </Grid>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Fragment>
                )}
            </section>
        </Fragment>
    );
}
